import { type AggregatePaginateResult, type CommentItem, type QueryParamsObject } from "@finway-group/shared/lib/models"
import { type DeliveryNoteDTO } from "@finway-group/shared/lib/models/deliveryNote/deliveryNoteDTO.model"
import { type DeliveryNoteLinkRequest } from "@finway-group/shared/lib/models/expense/linkRequest.interface"
import axios from "axios"
import { type PrevAndNextDocsResponse } from "@finway-group/shared/lib/models/adjacent/prevAndNextDocsResponse.interface"
import { type DeliveryNote } from "../types/deliveryNote.interfaces"

const MODEL = "delivery-notes"

export const DeliveryNoteApiService = {
    fetchDeliveryNotes: async ({ params, signal }: { params: QueryParamsObject; signal?: AbortSignal }): Promise<AggregatePaginateResult<DeliveryNote>> => {
        const { data } = await axios.get<AggregatePaginateResult<DeliveryNote>>(`/${MODEL}`, { params, signal })
        return data
    },

    getDeliveryNoteById: async (deliveryNoteId: string): Promise<DeliveryNote> => {
        const { data } = await axios.get<DeliveryNote>(`/${MODEL}/${deliveryNoteId}`)
        return data
    },

    createDeliveryNote: async (deliveryNote: DeliveryNoteDTO): Promise<DeliveryNote> => {
        const { data } = await axios.post<DeliveryNote>(`/${MODEL}`, deliveryNote)
        return data
    },

    updateDeliveryNote: async (id: string, deliveryNote: DeliveryNoteDTO): Promise<DeliveryNote> => {
        const { data } = await axios.put<DeliveryNote>(`/${MODEL}/${id}`, deliveryNote)
        return data
    },

    deleteDeliveryNote: async (deliveryNoteId: string): Promise<DeliveryNote> => {
        const { data } = await axios.delete(`/${MODEL}/${deliveryNoteId}`)
        return data
    },

    linkPurchaseOrder: async (deliveryNoteId: string, linkRequest: DeliveryNoteLinkRequest): Promise<DeliveryNote> => {
        const { data } = await axios.post<DeliveryNote>(`/${MODEL}/${deliveryNoteId}/link-purchase-order`, linkRequest)
        return data
    },

    createDeliveryNoteComment: async (deliveryNoteId: string, comment: CommentItem): Promise<DeliveryNote> => {
        const { data } = await axios.post<DeliveryNote>(`/${MODEL}/${deliveryNoteId}/comments`, comment)
        return data
    },

    updateDeliveryNoteComment: async (deliveryNoteId: string, deliveryNoteCommentId: string, deliveryNoteComment: CommentItem): Promise<DeliveryNote> => {
        const { data } = await axios.patch<DeliveryNote>(`/${MODEL}/${deliveryNoteId}/comments/${deliveryNoteCommentId}`, deliveryNoteComment)
        return data
    },

    deleteDeliveryNoteComment: async (deliveryNoteId: string, deliveryNoteCommentId: string): Promise<DeliveryNote> => {
        const { data } = await axios.delete<DeliveryNote>(`/${MODEL}/${deliveryNoteId}/comments/${deliveryNoteCommentId}`)
        return data
    },

    getAdjacentDeliveryNotes: async ({ id, params, signal }: { id: string; params: QueryParamsObject; signal?: AbortSignal }): Promise<PrevAndNextDocsResponse> => {
        const { data } = await axios.get<PrevAndNextDocsResponse>(`/${MODEL}/${id}/adjacent`, { params, signal })
        return data
    },
}
